var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUpDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.17806 1.19705C9.2698 1.06381 9.39255 0.954867 9.53575 0.879605C9.67895 0.804343 9.83829 0.765019 10.0001 0.765019C10.1618 0.765019 10.3212 0.804343 10.4644 0.879605C10.6076 0.954867 10.7303 1.06381 10.8221 1.19705L19.8221 14.1971C19.9262 14.347 19.9873 14.5226 19.9987 14.7048C20.0101 14.8871 19.9713 15.0689 19.8865 15.2307C19.8018 15.3924 19.6744 15.5278 19.5181 15.6222C19.3618 15.7166 19.1826 15.7663 19.0001 15.7661H1.00006C0.817902 15.7653 0.639397 15.7149 0.483739 15.6203C0.328082 15.5257 0.201162 15.3904 0.116628 15.2291C0.0320935 15.0677 -0.0068559 14.8864 0.00396806 14.7045C0.014792 14.5227 0.0749798 14.3472 0.178059 14.1971L9.17806 1.19705Z",
    fill: "#ABABAB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpDisabled);
export default __webpack_public_path__ + "static/media/arrowUpDisabled.bcf43e816ba47e8dff909936cdd1e16d.svg";
export { ForwardRef as ReactComponent };